export default __webpack_public_path__ + "static/media/Montserrat-MediumItalic.54b24d99.ttf";